import type {SessionState} from 'src/v2/state/store';
import type {Wallet} from '@stripe-internal/wallet-connect-wrapper';
import type {Mode} from 'src/state/usePayinSessionContext';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';

type Params = {
  sessionState: SessionState['state'];
  activeWallet: Wallet | null;
  mode: Mode;
  enablePayWithAnyCrypto: boolean;
};

export function getInitialScreen({
  sessionState,
  activeWallet,
  mode,
  enablePayWithAnyCrypto,
}: Params): {
  screen: SessionState['screen'];
  newWallet?: SessionState['newWallet'];
} {
  if (enablePayWithAnyCrypto) {
    return {screen: 'TOKEN_SELECT'};
  }

  switch (sessionState) {
    case 'fulfillment_complete':
    case 'setup_complete':
      return {screen: 'SUCCESS'};
    case 'canceled':
      return {screen: 'CANCELED'};
    case 'purchase_complete':
      return {screen: 'PAY'};
    // PayinSession is 'error' while SetupSession is 'failed'
    case 'error':
    case 'failed':
      return {screen: 'ERROR'};
    case 'checkout':
    default:
      // For checkout state and any other states, check wallet presence
      if (!activeWallet) {
        const installed = WalletRegistry.getInstalledExtensionWallets();
        if (installed.length === 1) {
          return {
            screen: 'NETWORK_SELECT',
            newWallet: {
              walletOption: installed[0],
              networkType: null,
            },
          };
        }
        return {screen: 'WALLET_SELECT'};
      }
      return {screen: mode === 'pay' ? 'PAY' : 'SETUP'};
  }
}
